/**
 * Product stats — contador animado + barra de progresso.
 * Dispara quando a seção entra na tela (IntersectionObserver, threshold 0.3).
 */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-stats').forEach(function (section) {
    var percents = section.querySelectorAll('[data-pst-percent]');
    var bars = section.querySelectorAll('[data-pst-bar]');
    if (!percents.length) return;

    var targets = Array.prototype.map.call(percents, function (el, i) {
      return {
        el: el,
        bar: bars[i] || null,
        target: parseInt(el.dataset.target, 10) || 0,
        current: 0,
      };
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.disconnect();

          var maxValue = Math.max.apply(
            null,
            targets.map(function (t) {
              return t.target;
            })
          );
          var duration = 2000;
          var tickInterval = maxValue > 0 ? Math.floor(duration / maxValue) : duration;

          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              targets.forEach(function (t) {
                if (t.bar) {
                  t.bar.style.transition = 'width ' + duration + 'ms linear';
                  t.bar.style.width = t.target + '%';
                }
              });
            });
          });

          var interval = setInterval(function () {
            var allDone = true;
            targets.forEach(function (t) {
              if (t.current < t.target) {
                t.current++;
                t.el.textContent = t.current;
                allDone = false;
              }
            });
            if (allDone) clearInterval(interval);
          }, tickInterval);
        });
      },
      { threshold: 0.3 }
    );

    observer.observe(section);
  });
});
